import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getData } from 'conversations-async-data/async-data/operators/getters';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { clearPerformanceMarksAndMeasures } from 'conversations-thread-view/performance-metrics/operators/gatherPerformanceMetrics';
import { UNIVERSAL_SIDEBAR_MARKERS } from '../../performance-metrics/constants/performanceConstants';
import { getAsyncPastConversations } from '../selectors/getPastConversations';
import { getCount } from '../operators/pastConversationsGetters';
import { jsx as _jsx } from "react/jsx-runtime";
function PastConversationsCardTitle({
  data: {
    isCollapsed
  }
}) {
  //Don't track how long this card's content takes to render if it's collapsed.
  if (isCollapsed) {
    const marker = `${UNIVERSAL_SIDEBAR_MARKERS.OTHER_CONVERSATIONS_CARD}`;
    clearPerformanceMarksAndMeasures(marker);
  }
  const asyncPastConversations = useSelector(getAsyncPastConversations);
  const pastConversationsCount = getCount(getData(asyncPastConversations));
  const hasCount = pastConversationsCount !== null && pastConversationsCount !== undefined;
  return hasCount ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.crm-integration.PastConversationsCard.otherConversationsWithCount",
    options: {
      count: pastConversationsCount
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.crm-integration.PastConversationsCard.otherConversations"
  });
}
PastConversationsCardTitle.displayName = 'PastConversationsCardTitle';
export default PastConversationsCardTitle;